import { enforceCompanyRequiredScope } from '~/middleware/company-required-gate'
import {
  extractRouteCompanyCode,
  extractRouteNavigationScope,
  isCompanyCodeValidForStructure,
  stripCompanyQueryFromRoute,
} from '~/stores/layout/navigation'
import { NAVIGATION_SCOPE } from '~/utils/lib/layout/types'

export default defineNuxtRouteMiddleware((to) => {
  const navigationScope = extractRouteNavigationScope(to)
  const structure_id = String(to.params?.dataId ?? '')
  const company_code = extractRouteCompanyCode(to)

  if (navigationScope !== NAVIGATION_SCOPE.COMPANY_REQUIRED)
    return normalizeInvalidCompanyQueryOnOptionalScopes()

  return enforceCompanyRequiredScope(to)

  function normalizeInvalidCompanyQueryOnOptionalScopes() {
    const shouldCheckScope = (
      navigationScope === NAVIGATION_SCOPE.DATA_ONLY
      || navigationScope === NAVIGATION_SCOPE.COMPANY_OPTIONAL
    )
    const hasCompanyQueryParam = Object
      .prototype
      .hasOwnProperty
      .call(to.query ?? {}, 'company')

    if (!shouldCheckScope || !hasCompanyQueryParam)
      return

    const isValid = isCompanyCodeValidForStructure({
      structure_id,
      company_code,
    })

    if (isValid)
      return

    return navigateTo(
      stripCompanyQueryFromRoute(to),
      { replace: true }
    )
  }
})
